import axios from "axios-config";

export const login = async (credentials) => {
  const response = await axios.post("/auth/v2/login", credentials, {
    withCredentials: true,
  });
  return response;
};
